/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_NameInputs */

const en_settings_profile_name = /** @type {(inputs: Settings_Profile_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const id_settings_profile_name = /** @type {(inputs: Settings_Profile_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Settings_Profile_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_profile_name = /** @type {((inputs?: Settings_Profile_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_profile_name(inputs)
	return en_settings_profile_name(inputs)
});